import { OrderFormValue } from './index';
var OrderFormContact = /*@__PURE__*/ (function () {
    function OrderFormContact() {
    }
    OrderFormContact.prototype.getCity = function () {
        return this.persdaten_city;
    };
    OrderFormContact.prototype.setCity = function (city) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(city)
            .setMin(1)
            .setMax(24)
            .setMand('Y')
            .setType('string');
        this.persdaten_city = formValue;
        return this;
    };
    OrderFormContact.prototype.getSalutation = function () {
        return this.persdaten_anrede;
    };
    OrderFormContact.prototype.setSalutation = function (salutation) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(salutation)
            .setMin(3)
            .setMax(5)
            .setMand('N')
            .setType('selection[Firma|Frau|Off|Herr]');
        this.persdaten_anrede = formValue;
        return this;
    };
    OrderFormContact.prototype.getLegalForm = function () {
        return this.persdaten_legal_form;
    };
    OrderFormContact.prototype.setLegalForm = function (legalForm) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(legalForm)
            .setMin(5)
            .setMax(6)
            .setMand('Y')
            .setType('selection[Firma|Person]');
        this.persdaten_legal_form = formValue;
        return this;
    };
    OrderFormContact.prototype.getAreaCode = function () {
        return this.persdaten_areacode;
    };
    OrderFormContact.prototype.setAreaCode = function (areaCode) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(areaCode)
            .setMin(3)
            .setMax(7)
            .setMand('N')
            .setType('numeric');
        this.persdaten_areacode = formValue;
        return this;
    };
    OrderFormContact.prototype.getStreet = function () {
        return this.persdaten_street;
    };
    OrderFormContact.prototype.setStreet = function (street) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(street)
            .setMin(1)
            .setMax(30)
            .setMand('Y')
            .setType('string|numeric');
        this.persdaten_street = formValue;
        return this;
    };
    OrderFormContact.prototype.getBirthMonth = function () {
        return this.persdaten_dob_month;
    };
    OrderFormContact.prototype.setBirthMonth = function (birthMonth) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(birthMonth)
            .setMin(1)
            .setMax(2)
            .setMand('Y')
            .setType('numeric');
        this.persdaten_dob_month = formValue;
        return this;
    };
    OrderFormContact.prototype.getLastName = function () {
        return this.persdaten_lastname;
    };
    OrderFormContact.prototype.setLastName = function (lastName) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(lastName)
            .setMin(1)
            .setMax(30)
            .setMand('Y')
            .setType('string');
        this.persdaten_lastname = formValue;
        return this;
    };
    OrderFormContact.prototype.getZipCode = function () {
        return this.persdaten_plz;
    };
    OrderFormContact.prototype.setZipCode = function (zipCode) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(zipCode)
            .setMin(1)
            .setMax(5)
            .setMand('Y')
            .setType('numeric');
        this.persdaten_plz = formValue;
        return this;
    };
    OrderFormContact.prototype.getEmail = function () {
        return this.persdaten_email;
    };
    OrderFormContact.prototype.setEmail = function (email) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(email)
            .setMin(7)
            .setMax(80)
            .setMand('Y')
            .setType('email');
        this.persdaten_email = formValue;
        return this;
    };
    OrderFormContact.prototype.getNationality = function () {
        return this.persdaten_nationality;
    };
    OrderFormContact.prototype.setNationality = function (nationality) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(nationality)
            .setMin(1)
            .setMax(50)
            .setMand('Y')
            .setType('string');
        this.persdaten_nationality = formValue;
        return this;
    };
    OrderFormContact.prototype.getBirthYear = function () {
        return this.persdaten_dob_year;
    };
    OrderFormContact.prototype.setBirthYear = function (birthYear) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(birthYear)
            .setMin(4)
            .setMax(4)
            .setMand('Y')
            .setType('numeric');
        this.persdaten_dob_year = formValue;
        return this;
    };
    OrderFormContact.prototype.getPassword = function () {
        return this.persdaten_kundenkennwort;
    };
    OrderFormContact.prototype.setPassword = function (password) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(password)
            .setMin(6)
            .setMax(10)
            .setMand('Y')
            .setType('string|numeric|only');
        this.persdaten_kundenkennwort = formValue;
        return this;
    };
    OrderFormContact.prototype.getFixednetCustomerNumber = function () {
        return this.persdaten_fixednet_customer_number;
    };
    OrderFormContact.prototype.setFixednetCustomerNumber = function (fixednetCustomerNumber) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(fixednetCustomerNumber)
            .setMin(0)
            .setMax(50)
            .setMand('N')
            .setType('string|numeric');
        this.persdaten_fixednet_customer_number = formValue;
        return this;
    };
    OrderFormContact.prototype.getContactPersonSalutation = function () {
        return this.persdaten_ansprechpartner_anrede;
    };
    OrderFormContact.prototype.setContactPersonSalutation = function (salutation) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(salutation)
            .setMin(3)
            .setMax(5)
            .setMand('N')
            .setType('selection[Firma|Frau|Off|Herr]');
        this.persdaten_ansprechpartner_anrede = formValue;
        return this;
    };
    OrderFormContact.prototype.getContactPersonFirstName = function () {
        return this.persdaten_ansprechpartner_firstname;
    };
    OrderFormContact.prototype.setContactPersonFirstName = function (firstName) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(firstName)
            .setMin(1)
            .setMax(30)
            .setMand('N')
            .setType('string');
        this.persdaten_ansprechpartner_firstname = formValue;
        return this;
    };
    OrderFormContact.prototype.getContactPersonLastName = function () {
        return this.persdaten_ansprechpartner_lastname;
    };
    OrderFormContact.prototype.setContactPersonLastName = function (lastName) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(lastName)
            .setMin(1)
            .setMax(30)
            .setMand('N')
            .setType('string');
        this.persdaten_ansprechpartner_lastname = formValue;
        return this;
    };
    OrderFormContact.prototype.getVerification = function () {
        return this.persdaten_verification;
    };
    OrderFormContact.prototype.setVerification = function (verification) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(verification)
            .setMin(6)
            .setMax(21)
            .setMand('Y')
            .setType('selection[Handelsregisterauszug|Gewerbeschein]');
        this.persdaten_verification = formValue;
        return this;
    };
    OrderFormContact.prototype.getCompanyName = function () {
        return this.persdaten_companyname;
    };
    OrderFormContact.prototype.setCompanyName = function (companyName) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(companyName)
            .setMin(1)
            .setMax(50)
            .setMand('N')
            .setType('string');
        this.persdaten_companyname = formValue;
        return this;
    };
    OrderFormContact.prototype.getBirthDay = function () {
        return this.persdaten_dob_day;
    };
    OrderFormContact.prototype.setBirthDay = function (birthDay) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(birthDay)
            .setMin(1)
            .setMax(2)
            .setMand('Y')
            .setType('numeric');
        this.persdaten_dob_day = formValue;
        return this;
    };
    OrderFormContact.prototype.getFirstName = function () {
        return this.persdaten_firstname;
    };
    OrderFormContact.prototype.setFirstName = function (firstName) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(firstName)
            .setMin(1)
            .setMax(30)
            .setMand('Y')
            .setType('string');
        this.persdaten_firstname = formValue;
        return this;
    };
    OrderFormContact.prototype.getStreetNumber = function () {
        return this.persdaten_houseno;
    };
    OrderFormContact.prototype.setStreetNumber = function (streetNumber) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(streetNumber)
            .setMin(1)
            .setMax(8)
            .setMand('Y')
            .setType('alphanumeric');
        this.persdaten_houseno = formValue;
        return this;
    };
    OrderFormContact.prototype.getPhone = function () {
        return this.persdaten_phone;
    };
    OrderFormContact.prototype.setPhone = function (phone) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(phone)
            .setMin(3)
            .setMax(10)
            .setMand('N')
            .setType('numeric');
        this.persdaten_phone = formValue;
        return this;
    };
    OrderFormContact.prototype.getUstID = function () {
        return this.persdaten_ustid;
    };
    OrderFormContact.prototype.setUstID = function (ustID) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(ustID)
            .setMin(7)
            .setMax(14)
            .setMand('N')
            .setType('string|numeric');
        this.persdaten_ustid = formValue;
        return this;
    };
    OrderFormContact.prototype.getRegisterNumber = function () {
        return this.persdaten_registerno;
    };
    OrderFormContact.prototype.setRegisterNumber = function (registerNumber) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(registerNumber)
            .setMin(2)
            .setMax(50)
            .setMand('N')
            .setType('string|numeric');
        this.persdaten_registerno = formValue;
        return this;
    };
    OrderFormContact.prototype.getRegisterType = function () {
        return this.persdaten_register_type;
    };
    OrderFormContact.prototype.setRegisterType = function (registerType) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(registerType)
            .setMin(2)
            .setMax(4)
            .setMand('N')
            .setType('selection[GR|HR A|HR B|Ja|VR|Off]');
        this.persdaten_register_type = formValue;
        return this;
    };
    OrderFormContact.prototype.getRegisterCity = function () {
        return this.persdaten_register_city;
    };
    OrderFormContact.prototype.setRegisterCity = function (registerCity) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(registerCity)
            .setMin(2)
            .setMax(50)
            .setMand('N')
            .setType('string|numeric');
        this.persdaten_register_city = formValue;
        return this;
    };
    OrderFormContact.prototype.getDivergentBillingAddress = function () {
        return this.persdaten_divergent_billing_address;
    };
    OrderFormContact.prototype.setDivergentBillingAddress = function (value) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(value)
            .setMin(2)
            .setMax(3)
            .setMand('N')
            .setType('selection[Ja|Off]');
        this.persdaten_divergent_billing_address = formValue;
        return this;
    };
    OrderFormContact.prototype.getDivergentBillingAddressName = function () {
        return this.persdaten_divergent_billing_address_name;
    };
    OrderFormContact.prototype.setDivergentBillingAddressName = function (divergentBillingAddressName) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(divergentBillingAddressName)
            .setMin(1)
            .setMax(50)
            .setMand('N')
            .setType('string');
        this.persdaten_divergent_billing_address_name = formValue;
        return this;
    };
    OrderFormContact.prototype.getDivergentBillingAddressStreet = function () {
        return this.persdaten_divergent_billing_address_street;
    };
    OrderFormContact.prototype.setDivergentBillingAddressStreet = function (divergentBillingAddressStreet) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(divergentBillingAddressStreet)
            .setMin(1)
            .setMax(50)
            .setMand('N')
            .setType('string');
        this.persdaten_divergent_billing_address_street = formValue;
        return this;
    };
    OrderFormContact.prototype.getDivergentBillingAddressHouseno = function () {
        return this.persdaten_divergent_billing_address_street;
    };
    OrderFormContact.prototype.setDivergentBillingAddressHouseno = function (divergentBillingAddressStreetNumber) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(divergentBillingAddressStreetNumber)
            .setMin(1)
            .setMax(8)
            .setMand('N')
            .setType('string');
        this.persdaten_divergent_billing_address_houseno = formValue;
        return this;
    };
    OrderFormContact.prototype.getDivergentBillingAddressZipCode = function () {
        return this.persdaten_divergent_billing_address_zipcode;
    };
    OrderFormContact.prototype.setDivergentBillingAddressZipCode = function (divergentBillingAddressZipCode) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(divergentBillingAddressZipCode)
            .setMin(1)
            .setMax(5)
            .setMand('Y')
            .setType('numeric');
        this.persdaten_divergent_billing_address_zipcode = formValue;
        return this;
    };
    OrderFormContact.prototype.getDivergentBillingAddressCity = function () {
        return this.persdaten_divergent_billing_address_city;
    };
    OrderFormContact.prototype.setDivergentBillingAddressCity = function (divergentBillingAddressCity) {
        var formValue = new OrderFormValue();
        formValue
            .setValue(divergentBillingAddressCity)
            .setMin(1)
            .setMax(8)
            .setMand('N')
            .setType('string');
        this.persdaten_divergent_billing_address_city = formValue;
        return this;
    };
    return OrderFormContact;
}());
export { OrderFormContact };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/order/order.form-contact.ts
// module id = null
// module chunks = 